declare namespace $ {

	export class $shm_hitalama_vk_group_search extends $shm_hitalama_components_embed {
		token_str( ): string
		dto( ): $shm_hitalama_vk_group_dto | null
		buttons( ): readonly($mol_view)[]
	}
	
}

//# sourceMappingURL=search.view.tree.d.ts.map